export default __webpack_public_path__ + "static/media/a078c93d7fc484880b91afd41bceb9df1600872615044.1fbefda2.webp";